export * from "./spriteMap.pure";

import "../Shaders/spriteMap.fragment";
import "../Shaders/spriteMap.vertex";
